import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { ProjectCardForm } from '../Project/ProjectCardForm';
import { ProjectActionCreators, AppActionCreators } from '../../../actions';
import { ProjectType } from '../../../utils/enums';
import { RouteUrls } from '../../../configs/routeUrls';

class ConsultationCardVoteContainer extends Component {
	constructor(props) {
		super(props);
		this.onGoBack = this.onGoBack.bind(this);
	}

	componentDidMount() {
		let { id } = this.props.match.params;
		if (id) {
			this.props.getProject(id);
		}
		this.props.setBreadcrumbs([
			{
				url: RouteUrls.Consultation.list.actual,
				displayName: 'Konsultacje'
			},
			{
				url: RouteUrls.Consultation.voteFunc(id),
				displayName: 'Konsultacja'
			}
		]);
	}

	onGoBack() {
		this.props.goBack();
	}

	render() {
		return (
			<ProjectCardForm
				{...this.props.project}
				consultationTitle="Konsultacja"
				disabled={false}
				isAuth={this.props.isAuth}
				loggedOfficeId={this.props.loggedOfficeId}
				loggedUserId={this.props.loggedUserId != null ? this.props.loggedUserId : 0}
				loggedUserIsCitizen={this.props.loggedUserIsCitizen}
				type={ProjectType.Consultation}
				externalSystemAddress={this.props.externalSystemAddress}
				isActCommentAdding={this.props.isActCommentAdding || false}
				isCommentAdding={this.props.isCommentAdding || false}
				addCommentOpinion={(id, type) => this.props.addCommentOpinion(id, type)}
				addProjectOpinion={(id, type) => this.props.addProjectOpinion(id, type)}
				onCancel={this.onGoBack}
				removeCommentOpinion={(id) => this.props.removeCommentOpinion(id)}
				removeProjectOpinion={(id) => this.props.removeProjectOpinion(id)}
				saveAnswers={this.props.updateConsultationForm}
				saveComment={(values) => this.props.saveComment(values)}
				isProjectLoading={this.props.isProjectLoading}
				opinionExecuting={this.props.opinionExecuting}
				voteExecuting={this.props.voteExecuting}
				isOnlyOneOffice={this.props.isOnlyOneOffice}
				isPreview={false}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isProjectLoading: state.project.isProjectLoading,
		opinionExecuting: state.project.opinionExecuting,
		voteExecuting: state.project.voteExecuting,
		project: state.project.project,
		loggedUserId: state.app.loggedUser.userId,
		isAuth: state.app.isAuth,
		loggedOfficeId: state.app.loggedUser.officeId,
		isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
		loggedUserIsCitizen: state.app.loggedUser.isCitizen,
		externalSystemAddress: state.app.officeFooter.eboi || '',
		isActCommentAdding: state.comment.isActCommentAdding || false,
		isCommentAdding: state.comment.isCommentAdding || false
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...ProjectActionCreators, ...AppActionCreators }, dispatch),
		...{
			goBack: () => dispatch(goBack())
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationCardVoteContainer);
